export default "__VITE_ASSET__DSELkYZ0__"